import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Skeleton,
  Tooltip,
  Typography
} from "@material-ui/core";
import ExpandMoreTwoTone from "@material-ui/icons/ExpandMoreTwoTone";
import moment from "moment";
import React from "react";
import { TypeToName } from "../PageFilter/FieldType";
import useExpanded from "../Provider/hooks/useExpanded";
import useList from "../Provider/hooks/useList";
import LogItemButtonShow from "./LogItemButtonShow";
import LogItemHaveError from "./LogItemHaveError";
import LogItemStatus from "./LogItemStatus";
import TableProducts from "./TableProducts";
import { LogItemFC } from "./types";

const LogItem: LogItemFC = ({
                              id,
                              status,
                              dateTime,
                              marketplace,
                              haveError,
                              countProducts,
                              type,
                              warehouse,
                            }) => {
  const { isExpanded, update } = useExpanded(id);
  const handlerChange = (e: React.SyntheticEvent, status: boolean) => {
    update(status);
  };
  const { isLoading } = useList();
  return (
    <Accordion
      expanded={isExpanded}
      onChange={handlerChange}
      disabled={isLoading}
    >
      <AccordionSummary expandIcon={ <ExpandMoreTwoTone style={{visibility: countProducts === 0 ? 'hidden' : 'visible'}}/> }>
        <Grid
          container
          spacing={1}
          sx={{ marginRight: 1 }}
          alignItems={"center"}
        >
          <Grid item>
            <LogItemStatus status={status} />
          </Grid>
          {haveError ? (
            <Grid item>
              <LogItemHaveError haveError={haveError} />
            </Grid>
          ) : null}
          <Grid item>
            <Typography variant={"body1"} noWrap>
              {isLoading ? <Skeleton width={150} /> : marketplace.name}
            </Typography>
          </Grid>
          {type ? (
            <Grid item>
              <Typography variant={"body1"} noWrap>
                {"("}
                {isLoading ? <Skeleton width={150} /> : TypeToName[type]}
                {")"}
              </Typography>
            </Grid>
          ) : null}
          <Grid item>
            <Tooltip title={"Обновленно товаров: " + countProducts}>
              <Typography variant={"body2"} noWrap>
                <Grid
                  container
                  flexWrap={"nowrap"}
                  spacing={1}
                  alignItems={"center"}
                >
                  <Grid item>{"Товаров:"}</Grid>
                  <Grid item>
                    {isLoading ? <Skeleton width={25} /> : countProducts}
                  </Grid>
                </Grid>
              </Typography>
            </Tooltip>
          </Grid>
          <Grid item>
            <Typography variant={"body2"} noWrap>
              <Grid
                  container
                  flexWrap={"nowrap"}
                  spacing={1}
                  alignItems={"center"}
              >
                <Grid item>{"Склад:"}</Grid>
                <Grid item>
                  {isLoading ? <Skeleton width={100} /> : warehouse ? warehouse.name : warehouse}
                </Grid>
              </Grid>
            </Typography>
          </Grid>
          <Grid item marginLeft={"auto"}>
            <Grid
              container
              flexWrap={"nowrap"}
              spacing={1}
              alignItems={"center"}
            >
              <Grid item>
                <Typography component={"span"} noWrap variant={"body1"}>
                  {isLoading ? (
                    <Skeleton width={75} />
                  ) : (
                    moment(dateTime).format("DD.MM.YYYY")
                  )}
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  component={"span"}
                  noWrap
                  variant={"body2"}
                  fontSize={"12px"}
                >
                  {isLoading ? (
                    <Skeleton width={75} />
                  ) : (
                    moment(dateTime).format("HH:mm:ss z")
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <LogItemButtonShow logId={id} />
          </Grid>
        </Grid>
      </AccordionSummary>
      {isExpanded ? (
        <AccordionDetails sx={{ padding: 0 }}>
          <Divider />
          <TableProducts logId={id} marketplace={marketplace} />
        </AccordionDetails>
      ) : null}
    </Accordion>
  );
};

export default LogItem;
